/** Flat navigation rows retain the existing active, collapsed, and color states. */
function collapseItem(theme, { active, sidenavColor }) {
  const { palette } = theme;
  const accent = !sidenavColor || sidenavColor === "default" ? palette.info : palette[sidenavColor];
  return {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minHeight: 44,
    padding: "10px",
    margin: "0 14px",
    borderRadius: "10px",
    border: "1px solid " + (active ? "#b4d52b" : "transparent"),
    background: active ? accent.main : "transparent",
    color: active ? accent.contrastText || palette.white.main : palette.text.main,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "none",
    transition: "background-color 150ms ease, color 150ms ease",
    "&::after": {
      content: active ? '""' : "none",
      width: 5,
      height: 5,
      flexShrink: 0,
      marginLeft: "auto",
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
    "&:hover": {
      background: active ? accent.main : palette.light.main,
      color: active ? accent.contrastText || palette.white.main : palette.dark.main,
    },
  };
}
function collapseIconBox() {
  return {
    minWidth: 20,
    minHeight: 20,
    display: "grid",
    placeItems: "center",
    color: "inherit",
    background: "transparent",
    boxShadow: "none",
    "& svg": { fontSize: "1.125rem", fill: "currentColor" },
  };
}
const collapseIcon = () => ({ color: "inherit" });

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(12.8),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12.8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.xs,
      lineHeight: 1.4,
    },
  };
}

function collapseArrow(theme, ownerState) {
  const { palette, typography, transitions, breakpoints, functions } = theme;
  const { noCollapse, transparentSidenav, miniSidenav, open } = ownerState;

  const { dark, gradients } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    display: noCollapse ? "none" : "block",
    fontSize: `${size.md} !important`,
    fontWeight: 700,
    marginBottom: pxToRem(-1),
    transform: open ? "rotate(0)" : "rotate(-180deg)",
    color: open ? dark.main : rgba(gradients.dark.state, 0.4),
    transition: transitions.create(["color", "transform", "opacity"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      display:
        noCollapse || (transparentSidenav && miniSidenav) || miniSidenav
          ? "none !important"
          : "block !important",
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText, collapseArrow };
